import classNames from "classnames";
import React, { useState } from "react";
import { useClickOutsideHandler } from "./Tools";
import { Dividers } from "Components/Dividers";

export function HeaderHamburger(props: {
  userEmail: string | null;
  dashboardUrl: string;
  openLinkInNewTab: boolean;
}) {
  const [isMenuVisible, setMenuVisible] = useState(false);
  const toggleMenu = () => setMenuVisible(!isMenuVisible);
  const ref = React.useRef(null);

  useClickOutsideHandler({
    isHandlerActive: isMenuVisible,
    handleClickOutside: () => setMenuVisible(false),
    elementRef: ref,
  });
  return (
    <div className="level-right is-flex">
      <div
        className={classNames("dropdown is-right", {
          "is-active": isMenuVisible,
        })}
        id="hamburger-menu"
        ref={ref}
      >
        <div className="dropdown-trigger">
          <button
            type="button"
            onClick={toggleMenu}
            style={{ fontSize: "20px" }}
            className={classNames("button", {
              "is-hidden-tablet": props.userEmail !== null,
            })}
          >
            <span className="icon">
              <i className="fa fa-bars" />
            </span>
          </button>

          {props.userEmail && (
            <button
              className="button is-hidden-mobile"
              aria-haspopup="true"
              aria-controls="dropdown-menu"
              onClick={toggleMenu}
            >
              <span>Welcome, {props.userEmail}</span>
              <span className="icon is-small">
                <i className="fa fa-angle-down" aria-hidden="true" />
              </span>
            </button>
          )}
        </div>
        <div className="dropdown-menu" role="menu">
          <div className="dropdown-content">
            <Dividers divider={<hr className="dropdown-divider" />}>
              <a
                href={`/Account/${
                  props.userEmail ? "LogOff" : "LogOn"
                }?returnUrl=${document.location.pathname}`}
              >
                <span className="dropdown-item">
                  {props.userEmail ? "Log Off" : "Log On"}
                </span>
              </a>
              {props.userEmail && (
                <a
                  href={props.dashboardUrl}
                  target={props.openLinkInNewTab ? "_blank" : undefined}
                >
                  <span className="dropdown-item">Dashboard</span>
                </a>
              )}
            </Dividers>
          </div>
        </div>
      </div>
    </div>
  );
}
